import { ITypedBaseResponse } from "@nkr/models/base-response";
import { AuthActionCreators } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useState } from "react";

interface IResponseItem {
    id: number,
    alias: string,
    name: string,
    address: string,
    city: string,
    state: string,
    postalCode: string,
    isActive: boolean,
    achApproved: boolean,
    isCenter: boolean,
    contactCount: number,
    hasAch: boolean
}

interface IRetVal {
    list: IResponseItem[],
    loading: boolean,
    error: string
}

const useOpoBaseList = (): IRetVal => {
    const { dispatch } = useAppHookContext();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [list, setList] = useState<IResponseItem[]>([]);

    useEffect(() => {
        setLoading(true);
        setError('');

        const fetchData = async () => {
            let config = {
                url: `${__API__}/admin/opo`,
            };

            try {
                const response: ITypedBaseResponse<IResponseItem[]> = await dispatch(AuthActionCreators.apiGet(config));

                if (response && response.data.results && response.data.success) {
                    setList(response.data.results);
                } else {
                    setError('Unable to load OPO data');
                    setList([]);
                }
            } catch (err) {
                setList([]);
                setError(err);
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, []);

    return { loading, error, list }
}

export default useOpoBaseList;
